module.exports = __webpack_public_path__ + "img/service-and-shop-filter-chevy.61bab53d.jpg";